/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminGetViewupPlusSnsAccountsReqQueryDto
 */
export interface AdminGetViewupPlusSnsAccountsReqQueryDto {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'page'?: number;
    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'limit'?: number;
    /**
     * 정렬 기준
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'sort'?: AdminGetViewupPlusSnsAccountsReqQueryDtoSortEnum;
    /**
     * 정렬 순서
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'order'?: AdminGetViewupPlusSnsAccountsReqQueryDtoOrderEnum;
    /**
     * 계정 상태
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'status'?: AdminGetViewupPlusSnsAccountsReqQueryDtoStatusEnum;
    /**
     * 검색 타입
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'searchType'?: AdminGetViewupPlusSnsAccountsReqQueryDtoSearchTypeEnum;
    /**
     * 검색어
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'keyword'?: string;
    /**
     * 시작일
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'startDate'?: string;
    /**
     * 종료일
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'endDate'?: string;
    /**
     * 관리자 설정 성별
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'gender'?: AdminGetViewupPlusSnsAccountsReqQueryDtoGenderEnum;
    /**
     * 관리자 설정 나이
     * @type {number}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'age'?: number;
    /**
     * 삭제된 계정 포함
     * @type {boolean}
     * @memberof AdminGetViewupPlusSnsAccountsReqQueryDto
     */
    'isDeleted'?: boolean;
}

export const AdminGetViewupPlusSnsAccountsReqQueryDtoSortEnum = {
    Point: 'point',
    UpdatedAt: 'updatedAt'
} as const;

export type AdminGetViewupPlusSnsAccountsReqQueryDtoSortEnum = typeof AdminGetViewupPlusSnsAccountsReqQueryDtoSortEnum[keyof typeof AdminGetViewupPlusSnsAccountsReqQueryDtoSortEnum];
export const AdminGetViewupPlusSnsAccountsReqQueryDtoOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type AdminGetViewupPlusSnsAccountsReqQueryDtoOrderEnum = typeof AdminGetViewupPlusSnsAccountsReqQueryDtoOrderEnum[keyof typeof AdminGetViewupPlusSnsAccountsReqQueryDtoOrderEnum];
export const AdminGetViewupPlusSnsAccountsReqQueryDtoStatusEnum = {
    All: 'all',
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected',
    Stop: 'stop'
} as const;

export type AdminGetViewupPlusSnsAccountsReqQueryDtoStatusEnum = typeof AdminGetViewupPlusSnsAccountsReqQueryDtoStatusEnum[keyof typeof AdminGetViewupPlusSnsAccountsReqQueryDtoStatusEnum];
export const AdminGetViewupPlusSnsAccountsReqQueryDtoSearchTypeEnum = {
    Id: 'id',
    SnsId: 'snsId'
} as const;

export type AdminGetViewupPlusSnsAccountsReqQueryDtoSearchTypeEnum = typeof AdminGetViewupPlusSnsAccountsReqQueryDtoSearchTypeEnum[keyof typeof AdminGetViewupPlusSnsAccountsReqQueryDtoSearchTypeEnum];
export const AdminGetViewupPlusSnsAccountsReqQueryDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminGetViewupPlusSnsAccountsReqQueryDtoGenderEnum = typeof AdminGetViewupPlusSnsAccountsReqQueryDtoGenderEnum[keyof typeof AdminGetViewupPlusSnsAccountsReqQueryDtoGenderEnum];


